/**
 * Language switching:
 * - Localhost: /en path prefix (theme dev locale files)
 * - Production/preview: POST /localization
 */
(function () {
  const DEV_QUERY_KEYS = ['_fd', 'pb'];
  const LOCAL_HOSTS = new Set(['127.0.0.1', 'localhost']);
  const LOCALE_STORAGE_KEY = 'bamboopacks_locale';
  const LOCALE_PREFIX_PATTERN = /^\/(en|de)(?=\/|$)/;

  function isLocalDevHost() {
    return LOCAL_HOSTS.has(window.location.hostname);
  }

  function stripLocalePrefix(pathname) {
    const stripped = pathname.replace(LOCALE_PREFIX_PATTERN, '');
    return stripped === '' ? '/' : stripped;
  }

  function buildLocalePath(iso) {
    const url = new URL(window.location.href);
    DEV_QUERY_KEYS.forEach((key) => url.searchParams.delete(key));
    url.searchParams.delete('locale');

    const basePath = stripLocalePrefix(url.pathname);

    if (iso === 'en') {
      url.pathname = basePath === '/' ? '/en' : `/en${basePath}`;
    } else {
      url.pathname = basePath;
    }

    return url.toString();
  }

  function buildPreviewReturnPath(themeId) {
    const path = window.location.pathname || '/';
    const params = new URLSearchParams(window.location.search);

    DEV_QUERY_KEYS.forEach((key) => params.delete(key));
    if (themeId) {
      params.set('preview_theme_id', String(themeId));
    }

    const qs = params.toString();
    return qs ? `${path}?${qs}` : path;
  }

  function switchLocaleLocal(iso) {
    try {
      localStorage.setItem(LOCALE_STORAGE_KEY, iso);
    } catch {
      /* ignore */
    }
    window.location.assign(buildLocalePath(iso));
  }

  function initLocaleSwitcher() {
    const configEl = document.getElementById('BambooLangConfig');
    let config = {};

    if (configEl) {
      try {
        config = JSON.parse(configEl.textContent);
      } catch {
        config = {};
      }
    }

    const localeButtons = document.querySelectorAll('.bamboo-lang-switch [data-locale]');
    const forms = document.querySelectorAll('.bamboo-lang-switch__form');

    if (isLocalDevHost()) {
      localeButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const iso = button.getAttribute('data-locale');
          if (!iso) return;
          switchLocaleLocal(iso);
        });
      });

      forms.forEach((form) => {
        form.addEventListener('submit', (event) => {
          event.preventDefault();
          const input = form.querySelector('input[name="locale_code"]');
          if (!input || !input.value) return;
          switchLocaleLocal(input.value);
        });
      });
      return;
    }

    // Production / Preview Environment
    localeButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const iso = button.getAttribute('data-locale');
        if (!iso) return;

        const form = document.createElement('form');
        form.method = 'POST';
        form.action = '/localization';
        form.style.display = 'none';

        const formTypeInput = document.createElement('input');
        formTypeInput.type = 'hidden';
        formTypeInput.name = 'form_type';
        formTypeInput.value = 'localization';
        form.appendChild(formTypeInput);

        const utf8Input = document.createElement('input');
        utf8Input.type = 'hidden';
        utf8Input.name = 'utf8';
        utf8Input.value = '✓';
        form.appendChild(utf8Input);

        const localeInput = document.createElement('input');
        localeInput.type = 'hidden';
        localeInput.name = 'locale_code';
        localeInput.value = iso;
        form.appendChild(localeInput);

        const returnInput = document.createElement('input');
        returnInput.type = 'hidden';
        returnInput.name = 'return_to';
        returnInput.value = buildPreviewReturnPath(config.themeId);
        form.appendChild(returnInput);

        document.body.appendChild(form);
        form.submit();
      });
    });

    forms.forEach((form) => {
      form.action = '/localization';
      let returnInput = form.querySelector('input[name="return_to"]');
      if (!returnInput) {
        returnInput = document.createElement('input');
        returnInput.type = 'hidden';
        returnInput.name = 'return_to';
        form.appendChild(returnInput);
      }
      returnInput.value = buildPreviewReturnPath(config.themeId);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLocaleSwitcher);
  } else {
    initLocaleSwitcher();
  }
})();
